import axios from "axios";

export const searchPostalCodeAndColonyIds = async (postalCode, Colony, token) => {
  const options = {
    method: 'GET',
    url: `${process.env.REACT_APP_URL}/crm/locations/postal_codes/${postalCode}`,
    headers: { Authorization: token },
  };
  const respIds = await axios.request(options).then(resp => {
    const id_postal_code = resp.data.id;
    const id_colony = resp.data.colonies.find(colony => colony.name === Colony)?.id;
    return {
      id_postal_code,
      id_colony
    };
  }).catch(() => {
    return {
      id_postal_code: null,
      id_colony: null
    };
  });
  return respIds;
};